import React from 'react';

interface NavigationButtonProps {
  message: {
    id: string;
    navigationButton?: {
      label: string;
      variant?: 'primary' | 'secondary' | 'outline';
      icon?: string;
    };
    hasPreview?: boolean;
  };
  onNavigate: (messageId: string) => void;
}

export const NavigationButton: React.FC<NavigationButtonProps> = ({ message, onNavigate }) => {
  if (!message.navigationButton || !message.hasPreview) return null;

  const { label, variant = 'primary', icon } = message.navigationButton;

  const getButtonStyles = (variant: string) => {
    const baseStyles = {
      padding: '8px 16px',
      borderRadius: '20px',
      border: 'none',
      fontSize: '14px',
      fontWeight: '500',
      cursor: 'pointer',
      display: 'inline-flex',
      alignItems: 'center',
      gap: '6px',
      marginTop: '12px',
      transition: 'all 0.2s ease',
    };

    switch (variant) {
      case 'primary':
        return {
          ...baseStyles,
          backgroundColor: '#4f46e5',
          color: 'white',
          boxShadow: '0 2px 4px rgba(79, 70, 229, 0.2)',
        };
      case 'secondary':
        return {
          ...baseStyles,
          backgroundColor: '#f3f4f6',
          color: '#374151',
          border: '1px solid #d1d5db',
        };
      case 'outline':
        return {
          ...baseStyles,
          backgroundColor: 'transparent',
          color: '#4f46e5',
          border: '1px solid #4f46e5',
        };
      default:
        return baseStyles;
    }
  };

  return (
    <button
      style={getButtonStyles(variant)}
      onClick={() => onNavigate(message.id)}
      onMouseEnter={e => {
        const target = e.target as HTMLButtonElement;
        if (variant === 'primary') {
          target.style.backgroundColor = '#4338ca';
          target.style.transform = 'translateY(-1px)';
          target.style.boxShadow = '0 4px 8px rgba(79, 70, 229, 0.3)';
        }
      }}
      onMouseLeave={e => {
        const target = e.target as HTMLButtonElement;
        if (variant === 'primary') {
          target.style.backgroundColor = '#4f46e5';
          target.style.transform = 'translateY(0)';
          target.style.boxShadow = '0 2px 4px rgba(79, 70, 229, 0.2)';
        }
      }}
    >
      {icon && <span>{icon}</span>}
      {label}
    </button>
  );
};
